import '../css/app.css';

import '@/utils/sentry';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import { I18nConfig } from '@/utils';
import * as Sentry from "@sentry/react";

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => title ? `${title} &bull; ${appName}` : appName,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob('./Pages/**/*.tsx')
        ),
    setup({ el, App, props }) {
        const defaultLocale = props?.initialPage?.props?.config?.locale ?? 'en';

        i18next
            .use(initReactI18next)
            .init({
                ...I18nConfig,
                lng: defaultLocale,
            });

        // Sync React/i18n locale with Inertia locale
        router.on('success', (event) => {
            if (event?.detail?.page?.props?.config?.locale !== undefined) {
                i18next.changeLanguage(event.detail.page.props.config.locale);
            }
        });

        if (import.meta.env.SSR) {
            hydrateRoot(el, <App {...props} />);
            return;
        }

        createRoot(el, {
            // Callback called when an error is thrown and not caught by an ErrorBoundary.
            onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
                console.warn('Uncaught error', error, errorInfo.componentStack);
            }),
            // Callback called when React catches an error in an ErrorBoundary.
            onCaughtError: Sentry.reactErrorHandler(),
            // Callback called when React automatically recovers from errors.
            onRecoverableError: Sentry.reactErrorHandler(),
        }).render(<App {...props} />);
    },
    progress: {
        includeCSS: false,
    }
});
